import { Component, OnInit } from '@angular/core';
import { topics } from './topics';

@Component({
    selector: 'app-voo',
    templateUrl: './voo.component.html',
    styleUrls: ['./voo.component.scss']
})
export class VooComponent implements OnInit {
    topics = [];
    selectedTopicIndex = -1;

    constructor() { }

    setSelectedTopic(index) {
        if (this.selectedTopicIndex === index) {
            this.selectedTopicIndex = -1;
        }
        else {
            this.selectedTopicIndex = index;
        }
    }

    ngOnInit() {
        this.topics = topics;
    }
}
